import React, { useEffect } from "react";
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useApi } from "../../../../common/hooks";
import { LicenceManagementService } from "../../../../api";
import style from "./Form.module.css";
import { setUpdateLicenceManagement } from "../../../../common/slice";
import styles from "../../../../common/components/customizable-form/block/Block.module.css";
import { translate } from "../../../../common/providers";

export default function FormEditProfile() {
	const { call: getProfile } = useApi(LicenceManagementService.getProfile);
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const [optionsProfiles, setOptionsProfiles] = React.useState([]);
	const [valueProfile, setValueProfile] = React.useState(licenceManagementStore.selectedUser?.profil?.toUpperCase());
	const dispatch = useDispatch();
	useEffect(() => {
		getProfile()
			.then((data) => {
				setOptionsProfiles(data);
			})
			.catch(console.error);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Grid container className={style.container}>
			<FormControl>
				<div className={styles.caption}>
					<span>{translate("license-management.users.edit-profile.label")}</span>
					<span>*</span>
				</div>
				<RadioGroup
					value={valueProfile}
					onChange={(e) => {
						setValueProfile(e.target.value);
						dispatch(setUpdateLicenceManagement({ editUser: { role: e.target.value.toUpperCase() } }));
					}}
				>
					{optionsProfiles?.map((item) => (
						<FormControlLabel
							control={<Radio />}
							label={item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()}
							value={item}
						/>
					))}
				</RadioGroup>
			</FormControl>
		</Grid>
	);
}
